import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryVehicleGroupAssignments } from "../../domain/repositories/repository-vehicle-group-assignments";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";

export type ListCommandButtonsVehicleGroupAssignmentsProps = Omit<
    ListCommandButtonsProps<RepositoryVehicleGroupAssignments>,
    "list" | "createForm" | "listState"
> & {
    readonly vehicleId: UUID;
};

import { store } from "../../store";

@observer
export class ListCommandButtonsVehicleGroupAssignments extends React.Component<ListCommandButtonsVehicleGroupAssignmentsProps> {
    constructor(props: ListCommandButtonsVehicleGroupAssignmentsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteVehicleGroupAssignments(ids: UUID[]): Promise<void> {
        await store.repositoryVehicleGroupAssignments.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                listState={store.serviceListStates.vehicleGroupAssignments}
                {...this.props}
                onDelete={this.deleteVehicleGroupAssignments}
            />
        );
    }
}
